import React from 'react';
import { LuArrowUp, LuArrowDown } from 'react-icons/lu';
import './KpiCard.css';

// Card de indicador (ícone colorido + valor + variação % vs. período
// anterior equivalente), reusado no dashboard e em outras telas com KPIs.
const KpiCard = ({ icon: Icon, color = 'purple', label, value, growth, subtitle, className = '' }) => {
  const hasGrowth = typeof growth === 'number' && !Number.isNaN(growth);
  const isPositive = hasGrowth && growth >= 0;

  return (
    <div className={`kpi-card ${className}`.trim()}>
      <div className={`kpi-card__icon kpi-card__icon--${color}`}>
        {Icon && <Icon size={22} />}
      </div>
      <div className="kpi-card__body">
        <span className="kpi-card__label">{label}</span>
        <span className="kpi-card__value">{value}</span>
        {hasGrowth ? (
          <span className={`kpi-card__growth ${isPositive ? 'is-positive' : 'is-negative'}`}>
            {isPositive ? <LuArrowUp size={14} /> : <LuArrowDown size={14} />}
            {Math.abs(growth).toFixed(1)}% {subtitle || 'vs período anterior'}
          </span>
        ) : (
          subtitle && <span className="kpi-card__growth kpi-card__growth--neutral">{subtitle}</span>
        )}
      </div>
    </div>
  );
};

export default KpiCard;
